import {
  Button, Dialog, DialogActions, DialogContent,
  DialogContentText, DialogTitle, Typography, makeStyles, Grid,
} from "@material-ui/core";
import _, { isEmpty, isFunction } from 'lodash';
import { useContext, useEffect, useRef, useMemo } from 'react';
import { useTranslation, Trans } from "react-i18next";
import { useSelector } from 'react-redux';

import DeclaracaoImportacaoContext from '../../../../../contexts/import/declaracao-importacao/DeclaracaoImportacaoContext';
import { selectDeclaracaoImportacao } from '../../../../../features/declaracao-importacao/declaracaoImportacaoSelectors';
import QCXFinalFormWizard from '../../../../../shared-components/final-form-wizard/QCXFinalFormWizard';
import QCXFormStepWizard from '../../../../../shared-components/form-step-wizard/QCXFormStepWizard';

import QCXFinalTextField from '../../../../../shared-components/final-text-field/QCXFinalTextField';
import QCXDeclaracaoImportacaoPagamentosForm from "../../../../../components/declaracao-importacao/QCXDeclaracaoImportacaoPagamentosForm";
import QCXFormTitle from '../../../../../components/form-title/QCXFormTitle';
import QCXDynamicFieldGroup from '../../../../../shared-components/dynamic-field-group/QCXDynamicFieldGroup';
import { isNaoCalculadaStatus } from '../../../../../utils/general/operations/operationUtils';
import { normalizeNumeral, unnormalizeNumeral } from '../../../../../utils/general/general-utils';
import { formatBrazilianNumericDecimal } from '../../../../../utils/hooks/form/field/formatters';
import useValidators from '../../../../../utils/hooks/useValidators';
import { maxValue } from '../../../../../utils/validators/field/validator';

import QCXFormSubtitle from '../../../../../components/form-title/QCXFormSubtitle';
import QCXFinalAlternativeCurrencyField from '../../../../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectCodigoReceitaAutocomplete from '../../../../../shared-components/final-select-codigo-receita-field/QCXSelectCodigoReceitaAutocomplete';
import { BRAZILIAN } from '../../../../../utils/hooks/form/field/mask-types';
import QCXFinalNumericDecimalField from '../../../../../shared-components/final-numeric-decimal-field/QCXFinalNumericDecimalField';
import QCXSelectIncotermCondicaoVendaAutocomplete from '../../../../../shared-components/final-select-incoterm-condicao-venda-field/QCXSelectIncotermCondicaoVendaAutocomplete';

import QCXInfoAlert from '../../../../../shared-components/alert/QCXInfoAlert';

const useStyles = makeStyles((theme) => ({
  gridFields: {
    paddingBottom: '16px',
  },
  moedaInternacionalFieldLeft: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '5px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
      paddingBottom: '16px',
    },
  },
  moedaInternacionalFieldRight: {
    [theme.breakpoints.up('md')]: {
      paddingLeft: '11px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '8px',
    },
    [theme.breakpoints.down('sm')]: {
      paddingLeft: 0,
    },
  },
  totaisInput: {
    '& .MuiInputBase-root': {
      outline: '1px solid #F39200',
    },
    '& .MuiFormLabel-root': {
      color: '#F39200',
    },
  },
}));


const handleValorNaMoedaOnBlur = () => null


const VisaoGeralFormStepWizard = ({...restProps }) => {

  const { t } = useTranslation();
  const classes = useStyles();
  const isConsult = true;


  const valorValidators = useMemo(() => useValidators([maxValue(999999999999.99)]), []);
  const intl = BRAZILIAN;

  const {
    idDiSelecionada,
    idFaturaSelecionada,
    fetchFaturaDiDuimpCapaByFaturaId: fetchById,
  } = useContext(DeclaracaoImportacaoContext);

  const di = useSelector(selectDeclaracaoImportacao);


  useEffect(() => console.log(di), [di])
 
  useEffect(() => {

    const handleFetchById = () => {
      if (idFaturaSelecionada) {
        fetchById(idFaturaSelecionada);
      }
    };

    handleFetchById();

  }, [idFaturaSelecionada]);


  const somarPagamentos = (values) => {
    let total = 0;
    values?.atributosAdicionais?.pagamentos?.forEach((pagamento) => {
      total += normalizeNumeral(pagamento.valorReal);
    });

    return unnormalizeNumeral(total, formatBrazilianNumericDecimal(2));
  };

  return (
    <>
      <QCXFormStepWizard
        initialValues={di}
        disableSubmitOnNext
        disablePristine
        onSubmit={() => null}
      >
        {({ values, form  }) => (
          <Grid container spacing={2}>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalTextField
                  id="text-field-numero-transmissao"
                  key="text-field-numero-transmissao"
                  label="Processo"
                  name="atributosAdicionais.processo"
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXSelectIncotermCondicaoVendaAutocomplete
                  id="select-field-incoterm"
                  key="select-field-incoterm"
                  name="incotermCondicaoVenda.id"
                  label={t('com.muralis.qcx.incoterm')}
                  disabled={isConsult}
                  initialValues={values}
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalNumericDecimalField
                  id="text-number-peso-bruto-field"
                  key="text-number-peso-bruto-field"
                  name="pesoBruto"
                  label={t('com.muralis.qcx.pesoBruto')}
                  scale={5}
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalNumericDecimalField
                  id="text-number-peso-liquido-field"
                  key="text-number-peso-liquido-field"
                  name="pesoLiquido"
                  label={t('com.muralis.qcx.pesoLiquido')}
                  scale={5}
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-moeda-vmle-field"
                  key="currency-valor-moeda-vmle-field"
                  name="mle.valorMoeda"
                  label={t('com.muralis.qcx.moeda.valorMoedaMLE')}
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-real-moeda-vmle-field"
                  key="currency-valor-real-moeda-vmle-field"
                  name="mle.valorReal"
                  label={t('com.muralis.qcx.moeda.valorMoedaMLEReais')}
                  intl={intl}
                  adorned
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-moeda-seguro-field"
                  key="currency-valor-moeda-seguro-field"
                  name="seguro.valorMoeda"
                  label={t('com.muralis.qcx.seguro.valorSeguroInternacionalMoeda')}
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-real-moeda-seguro-field"
                  key="currency-valor-real-moeda-seguro-field"
                  name="seguro.valorReal"
                  label={t('com.muralis.qcx.seguro.valorSeguroInternacionalReais')}
                  intl={intl}
                  adorned
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-moeda-despesasAcessorias-field"
                  key="currency-valor-moeda-despesasAcessorias-field"
                  name="despesasAcessorias.valorMoeda"
                  label="Valor das Despesas Acessórias na Moeda"
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <QCXFinalAlternativeCurrencyField
                  id="currency-valor-real-moeda-despesasAcessorias-field"
                  key="currency-valor-real-moeda-despesasAcessorias-field"
                  name="despesasAcessorias.valorReal"
                  label="Valor das Despesas Acessórias em Reais"
                  intl={intl}
                  adorned
                  disabled
                />
              </Grid>
            </Grid>

            <Grid item container xs={12} sm={6} md={6} lg={6}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                  <QCXFinalAlternativeCurrencyField
                    id="currency-valor-moeda-frete-territorio-nacional-field"
                    key="currency-valor-moeda-frete-territorio-nacional-field"
                    name="frete.valorFreteNacionalMoeda"
                    validate={valorValidators}
                    onBlur={handleValorNaMoedaOnBlur(
                      form,
                      values,
                      'frete.moeda',
                      'frete.valorFreteNacionalMoeda',
                      'frete.valorFreteNacionalReal'
                    )}
                    label={t('com.muralis.qcx.frete.valorFreteNacionalMoeda')}
                    disabled={isConsult || !values?.frete?.moeda?.id}
                  />
                </Grid>
              </Grid>

              <Grid item container xs={12} sm={6} md={6} lg={6}>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <QCXFinalAlternativeCurrencyField
                    id="currency-valor-real-moeda-frete-territorio-nacional-field"
                    key="currency-valor-real-moeda-frete-territorio-nacional-field"
                    name="frete.valorFreteNacionalReal"
                    label={t('com.muralis.qcx.frete.valorFreteNacionalReais')}
                    intl={intl}
                    adorned
                    disabled
                    helperText={!isConsult && t('com.muralis.qcx.mensagem.arredondamentoValor')}
                  />
                </Grid>
              </Grid>

              <>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <QCXFormTitle title={t('com.muralis.qcx.pagamento.fichaPagamentos')} />
                  </Grid>
                  {isEmpty(values?.atributosAdicionais?.pagamentos) && isNaoCalculadaStatus(values?.calculada) && (
                    <Grid item xs={12}>
                      <QCXInfoAlert>
                        <Trans i18nKey="com.muralis.qcx.mensagem.dadosRelacionadosGeradosDICalculada">
                          <em>
                            <strong>
                              {{
                                tributo: t('com.muralis.qcx.impostoTaxa').toLowerCase(),
                              }}
                            </strong>
                            <strong>
                              {{
                                dadosrelacionados: t('com.muralis.qcx.outrosDadosRelacionados').toLowerCase(),
                              }}
                            </strong>
                            <strong>
                              {{
                                DI: t('com.muralis.qcx.declaracaoImportacao'),
                              }}
                            </strong>
                            <strong>
                              {{
                                estado: t('com.muralis.qcx.estado.calculada').toLowerCase(),
                              }}
                            </strong>
                          </em>
                        </Trans>
                      </QCXInfoAlert>
                    </Grid>
                  )}
                  <QCXDynamicFieldGroup
                    rootName="atributosAdicionais.pagamentos"
                    list={values?.atributosAdicionais?.pagamentos}
                  >
                    {({ identificacao, valorReal, valorSiscomex, codigoReceita, novoCodigoReceita, index }) => (
                      <>
                        <Grid item xs={12} sm={12} md={4} lg={4}>
                          <QCXFinalTextField
                            id="text-identificacao-field"
                            key="text-identificacao-field"
                            name={identificacao?.name}
                            label={index === 0 ? t('com.muralis.qcx.impostosOuTaxas') : undefined}
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <QCXFinalAlternativeCurrencyField
                            id="currency-valor-field"
                            key="currency-valor-field"
                            name={valorReal?.name}
                            label={index === 0 ? t('com.muralis.qcx.valor') : undefined}
                            scale={2}
                            adorned
                            disabled
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <QCXFinalAlternativeCurrencyField
                            id="currency-valor-siscomex-field"
                            key="currency-valor-siscomex-field"
                            name={valorSiscomex?.name}
                            label={index === 0 ? t('com.muralis.qcx.banco.valorSiscomex') : undefined}
                            scale={2}
                            adorned
                            disabled={isConsult}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <QCXSelectCodigoReceitaAutocomplete
                            id="text-codigo-receita-field"
                            key="text-codigo-receita-field"
                            name={`${codigoReceita?.name}.id`}
                            label={index === 0 ? t('com.muralis.qcx.codigoReceita') : undefined}
                            disabled
                            initialValues={values}
                          />
                        </Grid>
                        <Grid item xs={12} sm={12} md={2} lg={2}>
                          <QCXSelectCodigoReceitaAutocomplete
                            id="text-novo-codigo-receita-field"
                            key="text-novo-codigo-receita-field"
                            name={`${novoCodigoReceita?.name}.id`}
                            label={index === 0 ? t('com.muralis.qcx.codigoReceitaAlterado') : undefined}
                            disabled
                            initialValues={values}
                          />
                        </Grid>
                      </>
                    )}
                  </QCXDynamicFieldGroup>

                  <Grid item container xs={12} style={{ paddingTop: '1vh' }}>
                    <Grid item xs={6}>
                      <QCXFormSubtitle title={`Valor total dos Impostos: R$ ${somarPagamentos(values)}`} />
                    </Grid>
                  </Grid>


                </Grid>
              </>
          </Grid>

        )}

      </QCXFormStepWizard>
    </>
  )
}


export default VisaoGeralFormStepWizard;